// comp/layout/UserPermission.js
import React from 'react'
import { useSelector } from 'react-redux'
import isUser from '../Utils/isUser'

const UserPermission = ({children}) => {
    const user = useSelector(state => state.user)
    return (
        <>
            {
                isUser(user.role) ? children : <p>You don't have permission to access this page</p>
            }
        </>
    )
}

export default UserPermission